ic-input-container .component-container {
  display: flex;
  flex-direction: column;
}
